import React from "react"
import { brandColors } from "./EOSThemeProvider"

export function Lines({ color = brandColors.lightNight }: { color?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 453 1501" xmlSpace="preserve">
      <path
        d="M.4 361.79V806.7h299.51l.05-37.37c-1.79-16.04-10.66-27.81-26.34-34.97-11.58-5.29-22.87-6.02-23.67-6.07H131.38v-73.2h73.48l94.08-92.93c.14-11.88 1.58-132.76.77-200.16h4.55c.85 70.66-.76 199.61-.78 201.15l-.01.94-.67.65-96.07 94.9h-70.8v64.1h114.18c.5.03 49.74 2.76 54.39 45.22l.01.25-.05 37.49h79.84V489.11c0-24.71 20.09-44.81 44.8-44.81H453v4.55h-23.9c-22.2 0-40.25 18.06-40.25 40.26V806.7H453v4.55h-64.15v183.62c0 22.2 18.05 40.25 40.25 40.25H453v4.55h-23.9c-24.71 0-44.8-20.1-44.8-44.8V811.25h-79.84l-.24 192.24V1200h-4.55v-196.51l.24-192.24H.4v389.16h453.07V361.79H.4z"
        style={{
          fill: "none",
        }}
      />
      <path
        d="M388.85 489.11V806.7H453v4.55h-64.15v183.62c0 22.2 18.05 40.25 40.25 40.25H453v4.55h-23.9c-24.71 0-44.8-20.1-44.8-44.8V811.25h-79.84l-.24 192.24V1501h-4.55v-497.51l.24-192.24H.4v-4.55h299.51l.05-37.37c-1.79-16.04-10.66-27.81-26.34-34.97-11.58-5.29-22.87-6.02-23.67-6.07H131.38v-73.2h73.48l94.08-92.93c.14-11.88 1.58-132.76.77-562.16h4.55c.85 432.66-.76 561.61-.78 563.15l-.01.94-.67.65-96.07 94.9h-70.8v64.1h114.18c.5.03 49.74 2.76 54.39 45.22l.01.25-.05 37.49h79.84V489.11c0-24.71 20.09-44.81 44.8-44.81H453v4.55h-23.9c-22.2 0-40.25 18.06-40.25 40.26z"
        style={{
          fill: color,
        }}
      />
    </svg>
  )
}
